export default "__VITE_ASSET__CBGeP3Wc__"